import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PadlockShieldSvg = function PadlockShieldSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.012 10.12h1.39v6.02H7.598v-6.02h1.39V8.5A3.01 3.01 0 0 1 12 5.49a3.013 3.013 0 0 1 3.012 3.01zm-1.39 0V8.5A1.62 1.62 0 0 0 12 6.88a1.623 1.623 0 0 0-1.622 1.62v1.62zm-4.634 1.39v3.24h6.024v-3.24z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 2.249h19v15.004L12 22.25l-9.5-4.996zm1.39 1.39v12.776L12 20.679l8.11-4.264V3.638z",
    clipRule: "evenodd"
  }));
};
export var PadlockShield = function PadlockShield(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PadlockShieldSvg
  }));
};